import React from 'react';
import { ApolloQueryResult, NetworkStatus } from '@apollo/client';

import ResearchItem, {
  ResearchTypes
} from '@buyside/components/presentation/ResearchItem/researchItem';
import ResearchItemLoading from '@buyside/components/presentation/ResearchItem/researchItemLoading';

import useInfiniteScroll from '@buyside/util/hooks/useInfiniteScroll';

import { PublicUserIdeasQuery, usePublicUserIdeasQuery } from '@interfaces/graphql-typings';

const PublicUserIdeas: React.FC<{
  anonymous: boolean;
  showUserDetails: boolean;
  userId: string;
}> = ({ anonymous, showUserDetails, userId }) => {
  const { data, error, fetchMore, networkStatus } = usePublicUserIdeasQuery({
    variables: { anonymous, userId },
    notifyOnNetworkStatusChange: true
  });

  const pageInfo = data?.userLookUp?.publishedIdeas?.pageInfo;

  useInfiniteScroll(
    Boolean(pageInfo?.hasNextPage),
    (): Promise<ApolloQueryResult<PublicUserIdeasQuery>> =>
      fetchMore({ variables: { userId, cursor: pageInfo?.endCursor } })
  );

  if (error) throw error;
  if (networkStatus === NetworkStatus.loading) return <ResearchItemLoading times={3} />;

  const { publishedIdeas } = data?.userLookUp || {};

  return (
    <>
      {publishedIdeas?.edges?.map(edge =>
        edge?.node ? (
          <ResearchItem
            {...edge.node}
            key={`idea-${edge.node.id}`}
            researchType={ResearchTypes.IDEA}
            showUserDetails={showUserDetails}
          />
        ) : null
      )}
      {networkStatus === NetworkStatus.fetchMore && <ResearchItemLoading times={3} />}
    </>
  );
};

export default PublicUserIdeas;
